import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import {
  ColumnSeries,
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  Tooltip,
  DataLabel,
  StackingBarSeries,
  Chart,
} from "@syncfusion/ej2-react-charts";
import { priceDisplay } from "../../Constants/CommonConstant";
import "jspdf-autotable";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class OverallSummaryPdf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDateTime: 0,
      ReportdataPayload:
        this.props.location.state.data !== undefined
          ? this.props.location.state.data
          : [],
      isAsp:
        this.props.location.state.isAsp !== undefined
          ? this.props.location.state.isAsp
          : false,
      entityType:
        this.props.location.state.entityType !== undefined
          ? this.props.location.state.entityType
          : "vm",
      listTb:
        this.props.location.state.listTb !== undefined
          ? this.props.location.state.listTb
          : "1",
      value: undefined,
      modalPDF: false,
      isOverall: false,
      isIndividual: false,
      errormessage: "",
      errorPopup: false,
      isFreeTrial: false,
      chartLeftImage: "",
      chartRightImage: "",
      resourceTypePalette: [
        "#C8FFFF",
        "#007FFF",
        "#C8C8C8",
        "#646464",
        "#9664FF",
        "#3200FF",
        "#00007F",
      ],
      costPalett: ["#C4C3C3", "#2500A1", "#7501AA", "#C100B4", "#008080"],
      perfPalett: ["#C4C3C3", "#C100B4", "#7501AA", "#2500A1", "#008080"],
      perfxAxis: {
        valueType: "Category",
        labelStyle: {
          size: window.innerWidth < 767 ? "12px" : "20px",
          fontWeight: "500",
          color: "#808080",
          fontFamily: "Poppins, sans-serif",
        },
      },
      perfyAxis: {
        title: "Relative Performance",
        labelFormat: "{value}%",
        labelStyle: {
          size: window.innerWidth < 767 ? "12px" : "20px",
          fontWeight: "500",
          color: "#808080",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: window.innerWidth < 767 ? "12px" : "20px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
      },
      legendSettings: {
        visible: true,
        position: "Bottom",
        margin: { top: 20 },
        textStyle: {
          textOverflow: "Wrap",
          fontFamily: "Poppins, sans-serif",
          size: window.innerWidth < 767 ? "11px" : "20px",
        },
        alignment: "Center",
        toggleVisibility: true,
      },
      legendSettings1: {
        visible: false,
        position: "Bottom",
        margin: { top: 20 },
        alignment: "Center",
        toggleVisibility: false,
        fontFamily: "Poppins, sans-serif",
        size: window.innerWidth < 767 ? "11px" : "20px",
      },
      legendSettings1: {
        visible: false,
        position: "Bottom",
        margin: { top: 20 },
        alignment: "Center",
        toggleVisibility: false,
        fontFamily: "Poppins, sans-serif",
        size: window.innerWidth < 767 ? "12px" : "20px",
      },
      legendSettingsProcess: {
        visible: true,
        position: "Bottom",
        margin: { top: 20 },
        textStyle: {
          textOverflow: "Wrap",
          fontFamily: "Poppins, sans-serif",
          size: window.innerWidth < 767 ? "12px" : "22px",
        },
        alignment: "Center",
        toggleVisibility: true,
      },
      titleStyle: {
        color: "#393939",
        size: window.innerWidth < 767 ? "12px" : "20px",
        fontWeight: "500",
        location: { x: "277", y: "26.5" },
      },
      marker: {
        dataLabel: {
          position: "Auto",
          visible: true,
          font: {
            color: "white",
            size: window.innerWidth < 767 ? "12px" : "20px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
          },
        },
      },
      costPerfMarker: {
        dataLabel: {
          position: "Outer",
          visible: true,
          font: {
            color: "#393939",
            size: window.innerWidth < 767 ? "12px" : "20px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
          },
        },
      },
      costxAxis: {
        valueType: "Category",
        labelStyle: {
          size: window.innerWidth < 767 ? "12px" : "20px",
          fontWeight: "500",
          color: "#808080",
          fontFamily: "Poppins, sans-serif",
        },
      },
      costyAxis: {
        title: "Monthly Cost Run Rate",
        titleStyle: {
          size: window.innerWidth < 767 ? "12px" : "20px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
        labelStyle: {
          size: window.innerWidth < 767 ? "12px" : "20px",
          fontWeight: "500",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
      },
      chartTitleStyle: {
        color: "#393939",
        fontWeight: "500",
        size: window.innerWidth < 767 ? "18px" : "20px",
        fontFamily: "Poppins, sans-serif",
      },
      progressxAxis: {
        valueType: "Category",
        labelStyle: {
          size: window.innerWidth < 767 ? "12px" : "20px",
          fontWeight: "500",
          color: "#808080",
          fontFamily: "Poppins, sans-serif",
        },
      },
      progressyAxis: {
        labelFormat: "{value}%",
        minimum: 0,
        maximum: 100,
        interval: 25,
        labelStyle: {
          size: window.innerWidth < 767 ? "12px" : "20px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
      },
      multiVMAnalysis: null,
      isClientSidePDF: false,
    };
  }

  async componentDidMount() {
    let responseJson = this.props.clientSidePdfData;
    if (responseJson) {
      if (responseJson.success === true && responseJson.data !== undefined) {
        this.setState({ providerName: responseJson.orgInfo.providerName });
        if (
          responseJson.data.vmCostGraph !== undefined &&
          responseJson.data.vmCostGraph.costChart !== undefined
        ) {
          let mxCost = Math.max.apply(
            Math,
            responseJson.data.vmCostGraph.costChart.map(function (o) {
              return o.cost;
            })
          );
          let interval = Math.round(mxCost / 4);
          let mxPerf = Math.max.apply(
            Math,
            responseJson.data.vmPerfGraph.perfChart.map(function (o) {
              return o.perf;
            })
          );
          let intervalPerf = Math.round(mxPerf / 4);
          await this.setState({
            costyAxis: {
              interval: interval,
              maximum: mxCost + interval,
              minimum: 0,
            },
            perfyAxis: {
              interval: intervalPerf,
              maximum: mxPerf + intervalPerf,
              minimum: 0,
            },
          });
        }

        //      Progress Chart
        let order = {
          percent_unanalyzed: "#6848D2",
          percent_analyzed: "#2500A1",
          percent_analysis_ineligible: "#D9CEFF",
          percent_analysis_error: "#A489FF",
          percent_validated: "#9BCCFF",
          percent_optimized: "#00A17A",
          percent_custom_sized: "#26DAAE",
        };

        let label = {
          percent_unanalyzed: "Unanalyzed",
          percent_analyzed: "Analyzed",
          percent_analysis_ineligible: "Analysis Ineligible",
          percent_analysis_error: "Analysis Issue",
          percent_validated: "Validated",
          percent_optimized: "Optimally Sized",
          percent_custom_sized: "Custom Sized",
        };

        if (this.state.isAsp || this.state.entityType === "db") {
          order = {
            percent_unanalyzed: "#6848D2",
            percent_analyzed: "#2500A1",
            percent_analysis_ineligible: "#D9CEFF",
            percent_analysis_error: "#A489FF",
            percent_optimized: "#00A17A",
            percent_custom_sized: "#26DAAE",
          };
        }

        let progressTitle = this.state.isAsp
          ? "Overall ASP Progress"
          : this.state.entityType === "db"
          ? "Overall DBaaS Progress"
          : "Overall VM Progress";

        let keysSorted = Object.keys(
          responseJson.data.vmProgressGraph.progressList[0]
        ).sort((a, b) => {
          return Object.keys(order).indexOf(a) - Object.keys(order).indexOf(b);
        });
        let fiterData = [];
        let data = responseJson.data.vmProgressGraph.progressList[0];

        keysSorted.map((value) => {
          if (
            parseInt(data[value]) !== 0 &&
            data[value] !== null &&
            value.startsWith("percent_")
          ) {
            let obj1 = {
              type: "StackingBar",
              dataSource: [
                {
                  resourceName: data.resourceName,
                  [value]: data[value],
                  [`actual_${value}`]: data[`actual_${value}`],
                },
              ],
              xName: "resourceName",
              yName: value,
              name: label[value],
              legendShape: "Rectangle",
              fill: order[value],
              marker: {
                dataLabel: {
                  visible: true,
                  font: { size: "20px", fontFamily: " Poppins, sans-serif" },
                },
              },
            };
            fiterData.push(obj1);
          }
        });

        Chart.Inject(
          Chart,
          StackingBarSeries,
          Category,
          Tooltip,
          Legend,
          DataLabel
        );

        let chart = new Chart({
          //Initializing Primary X Axis
          primaryXAxis: {
            valueType: "Category",
            labelStyle: {
              size: "20px",
              fontWeight: "500",
              color: "#808080",
              fontFamily: "Poppins, sans-serif",
            },
          },
          //Initializing Primary Y Axis
          primaryYAxis: {
            minimum: 0,
            maximum: 100,
            interval: 25,
            labelStyle: {
              size: "20px",
              fontWeight: "400",
              color: "#393939",
              fontFamily: "Poppins, sans-serif",
            },
            labelFormat: "{value}%",
          },
          chartArea: {
            border: {
              width: 1,
            },
          },
          series: fiterData,
          legendSettings: this.state.legendSettingsProcess,
          height: "300",
          title: '',
          titleStyle: this.state.chartTitleStyle,
          palettes: this.state.resourceTypePalette,
          pointRender: this.progressBarPointRenderer,
          axisLabelRender: this.axisLabelRender,
          marker: this.state.marker,
        });
        chart.appendTo("#renderChart");

        //     End Progress Chart

        await this.setState({
          value: responseJson.data,
          modalLoader: false,
          isFreeTrial: responseJson.orgInfo.plan === "FREE_TRIAL",
          currentDateTime: responseJson.orgInfo.currentDateTime,
          loggedInUser: responseJson.orgInfo.loggedInUser,
        });
      }
    }
  }

  axisLabelRender = (args) => {
    if (!isNaN(args.value) && !isNaN(args.axis.endLabel)) {
      args.text = "";
    }
  };
  axisPointRender = (args) => {
    var isCost = args.series.properties.yName === "cost";
    if (args.point.x === "ECONOMICAL") {
      args.fill = isCost ? "#2500A1" : "#2500A1";
    }
    if (args.point.x === "BALANCED") {
      args.fill = isCost ? "#7501AA" : "#7501AA";
    }
    if (args.point.x === "ENHANCED") {
      args.fill = isCost ? "#C100B4" : "#C100B4";
    }
    if (args.point.x === "OPTIMALLY SIZED") {
      args.fill = isCost ? "#008080" : "#008080";
    }
    //        if(args.point.y == 0){
    //            args.cancel = true;
    //        } else {
    if (
      args.point.x === "CURRENT" ||
      args.point.x === "ECONOMICAL" ||
      args.point.x === "BALANCED" ||
      args.point.x === "ENHANCED" ||
      args.point.x === "OPTIMALLY SIZED"
    ) {
      if (isCost) {
        args.point.y = parseFloat(args.point.y).toFixed(2);
        args.point.text = priceDisplay(
          args.point.y,
          this.state.value?.userCurrency
        );
      }
    }
    //}
  };

  progressBarPointRenderer = (args) => {
    if (args.point.y == 0) {
      args.cancel = true;
    } else {
      var text = "actual_" + args.series.properties.yName;
      if (
        args.series.properties.dataSource[0][text] !== undefined &&
        args.series.properties.dataSource[0][text] !== null
      ) {
        args.point.yValue = args.series.properties.dataSource[0][text];
      }
    }
  };

  render() {
  
    return (
      <div>
        <div
          className="container-verf container-verf-padding"
          role="main"
          style={{ marginTop: "50px" }}
        >
          <div
            className="rowContainer pageBgWhite"
            style={{
              width: "100%",
              margin: "0px 0px 0px 0px",
              borderRadius: "10px",
            }}
          >
            <div className="container1 boxShadow">
              <div
                id="summary_list_account"
                style={{ width: "100%", justifyContent: "space-between" }}
              >
                <div
                  className="reportChart"
                  id="summaryCostChart"
                  style={{
                    padding: "0px",
                    width: "100%",
                    paddingBottom: "40px",
                  }}
                >
                  <div id="summaryLeftChart">
                    <Row
                      id="summarycChart"
                      style={{ justifyContent: "center" }}
                    >
                      <Col sm="10">
                        <ChartComponent
                          id="summarycchart"
                          axisLabelRender={this.axisLabelRender}
                          pointRender={this.axisPointRender}
                          primaryXAxis={this.state.costxAxis}
                          primaryYAxis={this.state.costyAxis}
                          title=""
                          palettes={this.state.costPalett}
                          legendSettings={this.state.legendSettings1}
                        >
                          <Inject
                            services={[
                              ColumnSeries,
                              Legend,
                              DataLabel,
                              Category,
                            ]}
                          />
                          <SeriesCollectionDirective>
                            <SeriesDirective
                              dataSource={
                                this.state.value !== undefined
                                  ? this.state.value.vmCostGraph.costChart
                                  : []
                              }
                              xName="type"
                              yName="cost"
                              type="Column"
                              marker={this.state.costPerfMarker}
                            ></SeriesDirective>
                          </SeriesCollectionDirective>
                        </ChartComponent>
                      </Col>
                    </Row>
                    <Row
                      id="summarypChart"
                      style={{ justifyContent: "center" }}
                    >
                      <Col sm="10">
                        <ChartComponent
                          id="summarypchart"
                          axisLabelRender={this.axisLabelRender}
                          pointRender={this.axisPointRender}
                          primaryXAxis={this.state.perfxAxis}
                          primaryYAxis={this.state.perfyAxis}
                          palettes={this.state.perfPalett}
                          title=""
                          legendSettings={this.state.legendSettings1}
                        >
                          <Inject
                            services={[
                              ColumnSeries,
                              Legend,
                              DataLabel,
                              Category,
                            ]}
                          />
                          <SeriesCollectionDirective>
                            <SeriesDirective
                              dataSource={
                                this.state.value !== undefined
                                  ? this.state.value.vmPerfGraph.perfChart
                                  : []
                              }
                              xName="type"
                              yName="perf"
                              type="Column"
                              marker={this.state.costPerfMarker}
                            ></SeriesDirective>
                          </SeriesCollectionDirective>
                        </ChartComponent>
                      </Col>
                    </Row>

                    <Row
                      id="processChartReport"
                      style={{ justifyContent: "center" }}
                    >
                      <Col sm="9">
                        <div id="renderChart"></div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
              <div id="chartReport"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyDetails: state.companyDetails.data,
  };
};

export default connect(mapStateToProps, null)(withRouter(OverallSummaryPdf));
